import { Ability } from '@casl/ability'
import { initialAbility } from './config'
import storage from "@/lib/gms/storage"

const auth = storage.getItem("auth")

const ability = auth != null && auth.ability != null ? auth.ability : null

export default new Ability(ability || initialAbility)
